var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"frame",attrs:{"src":'https://special-pages.web.app/' + this.$route.query.route,"title":"SpecialPages"}})
}
var staticRenderFns = []

export { render, staticRenderFns }